import { render, staticRenderFns } from "./configurePayment.vue?vue&type=template&id=7c146c42"
import script from "./configurePayment.vue?vue&type=script&setup=true&lang=js"
export * from "./configurePayment.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports